import PropTypes from "prop-types";
import { setActiveSort } from "../../helpers/product";
import { useTranslation } from "react-i18next";
import { useBrands } from "../../hooks/brandsHooks/useBrands";

const ShopBrands = ({ getSortParams, brandsFilter, setBrandsFilter }) => {
  const { data: brands } = useBrands();
  const { t } = useTranslation();

  return (
    <div className="sidebar-widget mt-50">
      <h4 className="pro-sidebar-title">{t("filter_by_brand")} </h4>
      <div className="sidebar-widget-list mt-20">
        {brands ? (
          <ul>
            <li>
              <div className="sidebar-widget-list-left">
                <button
                  onClick={(e) => {
                    setBrandsFilter(brands.map((brand) => brand.id));
                  }}
                  className={`${
                    brandsFilter?.length == brands?.length ? "active" : ""
                  }`}
                >
                  <span className="checkmark" /> {t("all")} {t("brands")}{" "}
                </button>
              </div>
            </li>
            {brands.map((brand, key) => {
              return (
                <li key={key}>
                  <div className="sidebar-widget-list-left">
                    <button
                      onClick={(e) => {
                        if (brandsFilter?.includes(brand.id)) {
                          setBrandsFilter(
                            brandsFilter?.filter((id) => id != brand.id)
                          );
                        } else {
                          setBrandsFilter([...brandsFilter, brand.id]);
                        }
                      }}
                      className={`${
                        brandsFilter?.includes(brand.id) ? "active" : ""
                      }`}
                    >
                      <span className="checkmark" /> {brand.name}{" "}
                    </button>
                  </div>
                </li>
              );
            })}
          </ul>
        ) : (
          t("no_brands_found")
        )}
      </div>
    </div>
  );
};

ShopBrands.propTypes = {
  brands: PropTypes.array,
  getSortParams: PropTypes.func,
};

export default ShopBrands;
